export default "__VITE_ASSET__DS3G71NW__"